import './home.css';
import { getbyID } from "../../modules/datafunction";
import { inicio } from "../../modules/data";
import {card} from "../../modules/primecompo";

const genitem0=()=>{
    const idata=getbyID({item:0},inicio)
    const content0= 
        <div>
            <h1>{idata['title']}   </h1>
            <h1>    <strong>{idata['span']}</strong> </h1>
          
            <button>{idata['button']}</button>

        </div>;
    const content1=
        <img  alt="persona con audifonos" src={idata['img']} />;   

    return(
        [ content0,content1] 
        
    )


}
const genitem1=()=>{
    const idata=getbyID({item:1},inicio)
    const content0= 
        <div>
           
           <p> { idata['p']}</p> 

        </div>;

    const content1=
        <img  alt="audifonos" src={idata['img']} />;
    
    return(

        [ content1,content0] 
    )    



}
const genitem2=()=>{
   const idata=getbyID({item:2},inicio)
    const content0= 
        <div>
            <h1>{idata['title']} </h1>
            <p>{idata['p']}</p> 
        </div>;
    const content1=
        <img  alt="personaconcamisetablanca" src={idata['img']} />;   
    return(
        [ content0,content1] 
        
    ) 
}
const genitem3=()=>{
    const idata=getbyID({item:3},inicio)
    const content0= 
        <div>
            <h1>{idata['title']} <span>{idata['p']}</span>  </h1>
            
        </div>;
    const content1=
        <img  alt="libro" src={idata['img']} />;   
    return(
        [ content1,content0]    
    ) 

}
const genitem4=()=>{
    const idata=getbyID({item:4},inicio)
    const content0= 
        <div>
            <p>{idata['p']}</p> 
        </div>;
    const content1=
        <img  alt="mujer con audifonos" src={idata['img']} />;   
    return(
        [ content0,content1] 
        
    ) 

}
const genitem5=()=>{
    const idata=getbyID({item:5},inicio)
    const content0= 
        <div>
            <img  alt="telefono" src={idata['img0']} />
        </div>
    const content1=
        <div>
            <span>{idata['title']} </span>
            <div className='query'>
                
                
                <img alt="query0" src={idata['img1']} />
                <img alt="query1" src={idata['img2']} />


            </div>

            <div className='query'> 
            <img alt="android" src={idata['img3']} />
            <img alt="googleplay" src={idata['img4']} />
                
            </div>

           
        </div>
       
         
    return(
        [ content0,content1] 
        
    ) 
}
const genitem6=()=>{
    const idata=getbyID({item:6},inicio)
    const content0= 
        <div>
            <span>{idata['title']} </span>
            <p>{idata['p']}</p> 
        </div>;
    const content1=
        <div>
             <input type='email' placeholder={idata['placeholder']} /> 
             <button>{idata['button']}</button>
            
        </div>
       
    return(
        [ content0,content1] 
        
    ) 

}
const Home = () => { 
return(

        <div className="home">
            {card(genitem0()[0],genitem0()[1],"row0","row1")}
            {card(genitem1()[0],genitem1()[1],"row0","row1")} 
            {card(genitem2()[0],genitem2()[1],'row0','row1')}
            {card(genitem3()[0],genitem3()[1],'row1','row0')}
            {card(genitem4()[0],genitem4()[1],'row0','row1')}
            {card(genitem5()[0],genitem5()[1],'row0','row1')}
            {card(genitem6()[0],genitem6()[1],'row1','row0')}
        </div>   
            

        
           

        
       
        
    )

   
}

export default Home;